import React, { useState, useEffect, useContext } from 'react';
import {Stack} from '@shopify/polaris';
import {FormProvider, useFetch} from '@thinkwell/react.common';
import {EditForm, TextField, Select} from '@thinkwell/react.polaris';
import {ProductsContext} from '../contexts/Products'

export default function EditProduct(props) {
  const [products, fetchProducts, fetchProductsState, upsertProduct] = useContext(ProductsContext)

  const item = props.item || {}

  let coursesOptions = []
  if (item.courses && item.courses.length) {
    coursesOptions = [{value: '', label: 'Select course'}].concat(item.courses.map((c) => { return {value: c.id, label: c.name} }))
  }

  const onEditSave = (response) => {
    props.onSave && props.onSave(response)
    upsertProduct(response)
  }

  const onActive = (active) => {
    props.onActive && props.onActive(active)
  }

  return (
    <FormProvider data={{data: item}} rootName="product" omit={["courses"]}><EditForm
      active={props.active}
      onActive={onActive}
      onSave={onEditSave}
      url={`/products${item.id ? `/${item.id}` : ''}.json`}
      method={item.id ? 'put' : 'post'}
      title={item.id ? "Edit Product" : "Add Product"}>
      <TextField required
      label="Name"
      name="name"
      />
      <Select
        options={coursesOptions}
        label={{singular: 'default course', plural: 'default course'}}
        name="default_course_id"
      />
    </EditForm></FormProvider>
  );
}
